module.exports = __webpack_public_path__ + "static/media/fzj80-landcruiser-2.a09d050d.jpg";